import { css, unsafeCSS } from 'lit';
import stylesheet from './assets/popover-styles';

export const styles = css`
	${unsafeCSS(stylesheet)}

	:host {
		--dsc-popover-background: var(--sds-popover-background-color, var(--sds-color-surface-default, var(--sds-color-main-surface-default)));
		--dsc-popover-border-width: var(--sds-popover-border-width, var(--sds-border-sm));
		--dsc-popover-border-style: var(--sds-popover-border-style, solid);
		--dsc-popover-border-color: var(--sds-popover-border-color, var(--sds-color-border-default, var(--sds-color-main-border-default)));
		--dsc-popover-color: var(--sds-popover-text-color, var(--sds-color-text-default, var(--sds-color-main-text-default)));
		--dsc-popover-arrow-size: var(--sds-popover-arrow-size, 12px);
		--dsc-popover-border-radius: var(--sds-popover-border-radius, var(--sds-radius-sm));
		--dsc-popover-max-width: var(--sds-popover-max-width, 300px);
		--dsc-popover-padding: var(--sds-popover-padding, var(--sds-spacing-2xs) var(--sds-spacing-xs));
		--dsc-popover-box-shadow: var(--sds-popover-shadow, 0 0 1px 0 rgba(0, 0, 0, 0.14), 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 4px 8px 0 rgba(0, 0, 0, 0.12));
		--dsc-popover-placement: top;
	}

	/* Note: Designsystem's popover.css uses CSS that does not work in the shadow DOM.
	   These rules ensures that arrow positioning works for our popover.
	   Do not remove unless the CSS selectors from Designsystem works out of the box. */
	:host([data-floating|='top'])::before {
		rotate: 45deg;
		top: 100%;
	}
	:host([data-floating|='right'])::before {
		left: 0;
		rotate: 135deg;
	}
	:host([data-floating|='bottom'])::before {
		rotate: -135deg;
		top: 0;
	}
	:host([data-floating|='left'])::before {
		left: 100%;
		rotate: -45deg;
	}

	@keyframes ds-fade-in {
		from {
			opacity: 0;
		}
	}

	@media (prefers-reduced-motion: reduce) {
		:host {
			animation: none;
		}
	}
`;
